// extracted by mini-css-extract-plugin
module.exports = {"li":"list_li__Ry4Zy","ol":"list_ol__QTocl","ul":"list_ul__TM7Xk"};